import { render, staticRenderFns } from "./AllAssignedTerminalsTable.vue?vue&type=template&id=4b0985da&scoped=true&"
import script from "./AllAssignedTerminalsTable.vue?vue&type=script&lang=js&"
export * from "./AllAssignedTerminalsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllAssignedTerminalsTable.vue?vue&type=style&index=0&id=4b0985da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0985da",
  null
  
)

export default component.exports